(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clay-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('clay-finder')) return;

    // Older Safari (iPads before iOS 14): media queries there only take addListener.
    const onMedia = (query, fn) => (query.addEventListener ? query.addEventListener('change', fn) : query.addListener(fn));
    const offMedia = (query, fn) => (query.removeEventListener ? query.removeEventListener('change', fn) : query.removeListener(fn));

    class ClayFinder extends HTMLElement {
      connectedCallback() {
        if (this.ready) {
          // Moved on the page (the theme editor does this): listen again.
          this.listen();
          this.sync();
          return;
        }
        this.ready = true;
        this.items = Array.from(this.querySelectorAll('[data-cf-item]'));
        this.filters = Array.from(this.querySelectorAll('[data-cf-filter]'));
        this.mode = this.querySelector('[data-cf-mode]');
        this.speck = this.querySelector('[data-cf-filter="speck"]');
        this.speckField = this.querySelector('[data-cf-speck-field]');
        this.speckHint = this.speckField.querySelector('.cf__hint');
        this.count = this.querySelector('[data-cf-count]');
        this.empty = this.querySelector('[data-cf-empty]');
        this.more = this.querySelector('[data-cf-more]');
        this.headClear = this.querySelector('[data-cf-clear="head"]');
        this.expanded = false;
        this.phone = window.matchMedia('(max-width: 749px)');

        this.onChange = (event) => {
          if (event.target === this.mode) this.applyMode();
          else if (event.target.matches('[data-cf-filter]')) this.expanded = false;
          this.update();
        };
        this.onPhone = () => this.update();
        // Back and Forward: the browser puts the shopper's menu choices back after the page has loaded,
        // without telling the page, so read the menus again whenever the page is shown.
        this.onShow = () => this.sync();

        this.addEventListener('change', this.onChange);
        this.querySelectorAll('[data-cf-clear]').forEach((button) => button.addEventListener('click', () => this.reset()));
        this.more.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.update();
        });
        this.listen();
        this.sync();
      }

      disconnectedCallback() {
        if (!this.phone) return;
        offMedia(this.phone, this.onPhone);
        window.removeEventListener('pageshow', this.onShow);
      }

      listen() {
        onMedia(this.phone, this.onPhone);
        window.addEventListener('pageshow', this.onShow);
      }

      sync() {
        this.applyMode();
        this.update();
      }

      listingKey() {
        return this.mode.value === 'ship' ? 'Ship' : 'Pickup';
      }

      reset() {
        this.filters.forEach((select) => {
          select.value = 'any';
        });
        this.expanded = false;
        this.update();
      }

      applyMode() {
        const option = this.mode.options[this.mode.selectedIndex];
        const key = this.listingKey();
        this.dataset.mode = this.mode.value;
        this.querySelector('[data-cf-mode-name]').textContent = option.dataset.name + '.';
        this.querySelector('[data-cf-mode-text]').textContent = option.dataset.note;
        this.querySelector('[data-cf-basis]').textContent = option.dataset.basis;
        this.items.forEach((item) => {
          const href = item.dataset['href' + key];
          if (href) item.querySelector('.cf__card').setAttribute('href', href);
          item.querySelector('[data-cf-tag]').textContent = option.dataset.tag;
        });
      }

      update() {
        const shade = this.querySelector('[data-cf-filter="shade"]').value;
        const speckOff = shade !== 'dark';
        if (speckOff) this.speck.value = 'any';
        this.speck.disabled = speckOff;
        this.speckField.classList.toggle('is-off', speckOff);
        this.speck.options[0].textContent = this.speck.options[0].dataset[speckOff ? 'off' : 'on'];
        this.speckHint.textContent = this.speckHint.dataset[speckOff ? 'off' : 'on'];

        const value = (name) => this.querySelector('[data-cf-filter="' + name + '"]').value;
        const fire = value('fire');
        const method = value('method');
        const grog = value('grog');
        const speck = speckOff ? 'any' : value('speck');
        const has = 'has' + this.listingKey();

        const matches = this.items.filter((item) => {
          const d = item.dataset;
          return d[has] === 'true' &&
            (fire === 'any' || d.fire.split(' ').indexOf(fire) !== -1) &&
            (method === 'any' || d.method.split(' ').indexOf(method) !== -1) &&
            (grog === 'any' || d.grog === grog) &&
            (shade === 'any' || d.shade === shade) &&
            (speck === 'any' || d.speck === speck);
        });

        const limit = Number(this.phone.matches ? this.dataset.initialMobile : this.dataset.initial) || 8;
        const shown = this.expanded ? matches.length : Math.min(limit, matches.length);
        this.items.forEach((item) => {
          item.hidden = true;
        });
        matches.forEach((item, index) => {
          item.hidden = index >= shown;
        });

        const n = matches.length;
        this.count.textContent = n === 0 ? 'No clays match' : n === 1 ? '1 clay matches' : n + ' clays match';
        this.empty.hidden = n !== 0;
        this.more.hidden = n <= limit;
        this.more.textContent = this.expanded ? 'Show fewer' : 'Show all ' + n + ' matches';
        this.more.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
        this.headClear.hidden = [fire, method, grog, shade, speck].every((v) => v === 'any');
      }
    }

    customElements.define('clay-finder', ClayFinder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sp-finder')) return;

    // Older Safari (iPads before iOS 14): media queries there only take addListener.
    const onMedia = (query, fn) => (query.addEventListener ? query.addEventListener('change', fn) : query.addListener(fn));
    const offMedia = (query, fn) => (query.removeEventListener ? query.removeEventListener('change', fn) : query.removeListener(fn));
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const norm = (s) => String(s == null ? '' : s).trim().toLowerCase();
    const num = (s) => {
      if (typeof s === 'number') return s;
      const n = parseFloat(String(s == null ? '' : s).replace(/[^0-9.\-]/g, ''));
      return isNaN(n) ? null : n;
    };
    const money = (cents) => {
      const d = cents / 100;
      return '$' + d.toLocaleString('en-US', { minimumFractionDigits: d % 1 ? 2 : 0, maximumFractionDigits: 2 });
    };

    // One request per collection and order, shared by every finder on the page.
    const cache = {};
    const parseData = (html) => {
      const m = html.match(/<script type="application\/json" data-spf-data>([\s\S]*?)<\/script>/);
      if (!m) throw new Error('No finder data in the response');
      return JSON.parse(m[1]);
    };
    // sort: 'best-selling', or '' for the collection's own order.
    const load = (handle, sort) => {
      const key = handle + '|' + sort;
      if (cache[key]) return cache[key];
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const get = (page) => fetch(root + 'collections/' + encodeURIComponent(handle) + '?section_id=finder-data' + (sort ? '&sort_by=' + encodeURIComponent(sort) : '') + '&page=' + page, { credentials: 'same-origin' })
        .then((r) => {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(parseData);
      cache[key] = get(1).then((first) => {
        const pages = Math.min(first.pages || 1, 20);
        const rest = [];
        for (let p = 2; p <= pages; p += 1) rest.push(get(p));
        return Promise.all(rest).then((more) => more.reduce((all, page) => all.concat(page.items), first.items));
      });
      cache[key].catch(() => {
        delete cache[key];
      });
      return cache[key];
    };

    // "Label = value" per line; for number ranges "Label = 1000 to 1499.99" (either end may be left out).
    const parseOptions = (text, between) => String(text || '').split(/\r?\n/).map((line) => line.trim()).filter(Boolean).map((line) => {
      const i = line.lastIndexOf('=');
      const label = (i === -1 ? line : line.slice(0, i)).trim();
      const value = (i === -1 ? line : line.slice(i + 1)).trim();
      const option = { label: label, value: value, min: null, max: null };
      if (between) {
        const m = value.match(/^([^a-z]*?)\s*(?:\bto\b|–|-)\s*([^a-z]*)$/i);
        if (m) {
          option.min = m[1].trim() === '' ? null : num(m[1]);
          option.max = m[2].trim() === '' ? null : num(m[2]);
        } else {
          option.min = num(value);
          option.max = option.min;
        }
      }
      return option;
    });

    // Price bands from the prices themselves, in round steps.
    const autoBands = (prices) => {
      if (prices.length < 2) return [];
      const lo = Math.min.apply(null, prices);
      const hi = Math.max.apply(null, prices);
      const steps = [10, 25, 50, 100, 250, 500, 1000, 2500, 5000, 10000];
      let step = steps[steps.length - 1];
      for (let i = 0; i < steps.length; i += 1) {
        if ((hi - lo) / steps[i] <= 5) {
          step = steps[i];
          break;
        }
      }
      const fmt = (n) => '$' + n.toLocaleString('en-US');
      const bands = [];
      let from = Math.ceil(lo / step) * step;
      if (from <= lo) from += step;
      bands.push({ label: 'Under ' + fmt(from), value: '', min: null, max: from - 0.01 });
      while (from + step < hi) {
        bands.push({ label: fmt(from) + ' to ' + fmt(from + step), value: '', min: from, max: from + step - 0.01 });
        from += step;
      }
      bands.push({ label: fmt(from) + ' and up', value: '', min: from, max: null });
      return bands;
    };

    class SpFinder extends HTMLElement {
      connectedCallback() {
        // Moved in the page (the theme editor does this): listen again, and keep waiting if it hasn't loaded yet.
        if (this.ready) {
          this.listen();
          if (!this.started && !this.nearObserver) this.startWhenNear();
          this.update();
          return;
        }
        this.ready = true;
        this.cfg = JSON.parse(this.querySelector('[data-spf-config]').textContent);
        this.filtersBox = this.querySelector('[data-spf-filters]');
        this.stock = this.querySelector('[data-spf-stock]');
        this.sort = this.querySelector('[data-spf-sort]');
        this.sortField = this.querySelector('[data-spf-sort-field]');
        this.stockName = this.querySelector('[data-spf-stock-name]');
        this.stockText = this.querySelector('[data-spf-stock-text]');
        this.count = this.querySelector('[data-spf-count]');
        this.basis = this.querySelector('[data-spf-basis]');
        this.grid = this.querySelector('[data-spf-grid]');
        this.empty = this.querySelector('[data-spf-empty]');
        this.error = this.querySelector('[data-spf-error]');
        this.more = this.querySelector('[data-spf-more]');
        this.allBtn = this.querySelector('[data-spf-all]');
        this.headClear = this.querySelector('.spf__head [data-spf-clear]');
        this.phone = window.matchMedia('(max-width: 749px)');
        this.expanded = false;
        this.items = null;
        this.stockDefault = this.cfg.stockDefault ? 'in' : 'any';
        if (this.stock) this.stock.value = this.stockDefault;
        this.showStockNote();

        this.filters = (this.cfg.filters || []).map((f, index) => {
          const between = f.match === 'Between' || (f.source === 'Price' && f.match !== 'Is');
          return {
            index: index,
            label: f.label || 'Filter',
            source: f.source || 'Product field',
            field: String(f.field || '').trim(),
            match: between ? 'Between' : f.match || 'Is',
            any: f.any || 'Any ' + String(f.label || '').toLowerCase(),
            hint: f.hint || '',
            options: parseOptions(f.options, between),
            auto: !String(f.options || '').trim(),
            select: null
          };
        });

        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-spf-filter], [data-spf-stock]')) this.expanded = false;
          this.update();
        });
        this.querySelectorAll('[data-spf-clear]').forEach((button) => button.addEventListener('click', () => this.reset()));
        this.more.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.update();
        });
        this.allBtn.addEventListener('click', () => {
          if (this.stock) this.stock.value = 'any';
          this.expanded = false;
          this.update();
        });
        this.querySelector('[data-spf-retry]').addEventListener('click', () => this.start());
        this.onPhone = () => this.update();
        // Back and Forward: the finder keeps the shopper's choices with this page in the browser history and puts
        // them back itself (remember, recall). The browser's own memory of the menus is off (autocomplete="off"):
        // it puts choices back by menu position, and the menus this finder adds shift those positions.
        // Whenever the page is shown, read the menus again in case they changed anyway.
        this.onShow = () => {
          if (this.menus() === this.applied) return;
          this.expanded = false;
          this.update();
        };
        this.listen();
        this.startWhenNear();
      }

      disconnectedCallback() {
        if (this.nearObserver) {
          this.nearObserver.disconnect();
          this.nearObserver = null;
        }
        if (!this.phone) return;
        offMedia(this.phone, this.onPhone);
        window.removeEventListener('pageshow', this.onShow);
      }

      listen() {
        onMedia(this.phone, this.onPhone);
        window.addEventListener('pageshow', this.onShow);
      }

      menus() {
        return [this.stock ? this.stock.value : '', this.sort.value].concat(this.filters.map((f) => (f.select ? f.select.value : ''))).join('|');
      }

      // Keep the shopper's choices with this page in the browser history, by the words on the menus,
      // so a filter whose list changed in the meantime never picks the wrong thing.
      remember() {
        const state = history.state;
        if (state != null && (typeof state !== 'object' || Array.isArray(state))) return;
        const choices = { stock: this.stock ? this.stock.value : '', sort: this.sort.value, filters: {} };
        this.filters.forEach((f) => {
          if (f.select && f.select.value !== '') choices.filters[f.label] = f.select.options[f.select.selectedIndex].text;
        });
        const next = Object.assign({}, state);
        next['spf:' + this.id] = choices;
        try {
          history.replaceState(next, '');
        } catch (e) {
          // Some browsers limit how often the history can change; the choices just aren't kept then.
        }
      }

      recall() {
        const saved = history.state && history.state['spf:' + this.id];
        if (!saved) return;
        const choose = (select, value) => {
          if (select && Array.from(select.options).some((o) => o.value === value)) select.value = value;
        };
        choose(this.stock, saved.stock);
        choose(this.sort, saved.sort);
        this.filters.forEach((f) => {
          const text = saved.filters && saved.filters[f.label];
          const option = f.select && text ? Array.from(f.select.options).find((o) => o.text === text) : null;
          if (option) f.select.value = option.value;
        });
      }

      // Load the products only when the finder comes within about two screens of view, so a finder low on a page
      // (the homepage) costs nothing for visitors who never scroll to it. Without IntersectionObserver, or in the
      // theme editor (products inline), load straight away.
      startWhenNear() {
        if (this.querySelector('[data-spf-inline]') || !('IntersectionObserver' in window)) {
          this.start();
          return;
        }
        this.nearObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.nearObserver.disconnect();
          this.nearObserver = null;
          this.start();
        }, { rootMargin: '200% 0px' });
        this.nearObserver.observe(this);
      }

      start() {
        this.started = true;
        this.error.hidden = true;
        this.count.textContent = 'Loading ' + this.cfg.many + '…';
        const inline = this.querySelector('[data-spf-inline]');
        const got = inline ? Promise.resolve(JSON.parse(inline.textContent).items) : load(this.cfg.collection, this.cfg.sort == null ? 'best-selling' : this.cfg.sort);
        got.then((items) => {
          this.items = items;
          this.buildFilters();
          this.recall();
          this.update();
        }).catch(() => {
          this.count.textContent = '';
          this.error.hidden = false;
        });
      }

      values(item, f) {
        let raw;
        if (f.source === 'Brand') raw = item.v;
        else if (f.source === 'Product type') raw = item.y;
        else if (f.source === 'Price') raw = item.p / 100;
        else if (f.source === 'Tag') {
          const prefix = norm(f.field).replace(/[\s:]+$/, '');
          raw = (item.g || []).filter((t) => norm(t).indexOf(prefix) === 0).map((t) => t.slice(prefix.length).replace(/^[\s:]+/, ''));
        } else raw = item.x ? item.x[f.field] : null;
        if (raw == null) return [];
        if (!Array.isArray(raw)) raw = [raw];
        return raw.map((v) => (v && typeof v === 'object' && 'value' in v ? v.value : v)).filter((v) => v !== '' && v != null);
      }

      test(item, f, option) {
        const vals = this.values(item, f);
        if (f.match === 'Between') {
          return vals.some((v) => {
            const n = num(v);
            return n != null && (option.min == null || n >= option.min) && (option.max == null || n <= option.max);
          });
        }
        const want = norm(option.value);
        if (f.match === 'Includes') return vals.some((v) => norm(v).indexOf(want) !== -1);
        return vals.some((v) => norm(v) === want);
      }

      buildFilters() {
        const items = this.items;
        // Replace only the generated filters, so Show first (and focus on it) stays put.
        this.filtersBox.querySelectorAll('[data-spf-made]').forEach((el) => el.remove());
        this.filters.forEach((f) => {
          let options = f.options;
          if (f.auto) {
            if (f.match === 'Between') {
              options = autoBands(items.map((item) => this.values(item, f)).reduce((a, b) => a.concat(b), []).map(num).filter((n) => n != null));
            } else {
              const seen = {};
              items.forEach((item) => this.values(item, f).forEach((v) => {
                const key = norm(v);
                if (!(key in seen)) seen[key] = v;
              }));
              options = Object.keys(seen).map((key) => {
                const v = seen[key];
                return { label: v === true ? 'Yes' : v === false ? 'No' : String(v), value: String(v) };
              });
              const numeric = options.every((o) => num(o.value) != null && /^[\d.\s]+$/.test(o.value));
              options.sort((a, b) => (numeric ? num(a.value) - num(b.value) : a.label.localeCompare(b.label)));
            }
          }
          // Keep the choices that find something, and show the filter only if one of them narrows the list.
          const usable = options.filter((o) => items.some((item) => this.test(item, f, o)));
          f.list = usable;
          f.select = null;
          if (!usable.some((o) => items.some((item) => !this.test(item, f, o)))) return;
          const id = this.id + '-f' + f.index;
          const label = document.createElement('label');
          label.className = 'spf__field';
          label.setAttribute('data-spf-made', '');
          label.innerHTML = esc(f.label) +
            '<select data-spf-filter autocomplete="off"' + (f.hint ? ' aria-describedby="' + id + '-hint"' : '') + '>' +
            '<option value="">' + esc(f.any) + '</option>' +
            usable.map((o, i) => '<option value="' + i + '">' + esc(o.label) + '</option>').join('') +
            '</select>' + (f.hint ? '<span class="spf__hint" id="' + id + '-hint">' + esc(f.hint) + '</span>' : '');
          f.select = label.querySelector('select');
          if (this.sortField && this.sortField.parentNode === this.filtersBox) this.filtersBox.insertBefore(label, this.sortField);
          else this.filtersBox.appendChild(label);
        });
      }

      showStockNote() {
        if (!this.stock || !this.stockName) return;
        if (this.stock.selectedIndex < 0) this.stock.value = this.stockDefault;
        const all = this.stock.value === 'any';
        this.stockName.textContent = this.stock.options[this.stock.selectedIndex].text + '.';
        this.stockText.textContent = all ? 'Every ' + this.cfg.one + ' we sell, including ones we don’t have in stock right now.' : this.cfg.stockNote || '';
      }

      inStock(item) {
        const tag = norm(this.cfg.stockTag);
        return tag && !this.cfg.stockField ? (item.g || []).some((t) => norm(t) === tag) : !!item.s;
      }

      // "In stock", or "In stock: 240/1 and 208/3" when only some of the product's options are.
      stockWords(item) {
        const w = item.w || [];
        if (!this.cfg.stockField || !w.length) return 'In stock';
        return 'In stock: ' + (w.length < 3 ? w.join(' and ') : w.slice(0, -1).join(', ') + ' and ' + w[w.length - 1]);
      }

      madeToOrder(item) {
        const tag = norm(this.cfg.orderTag);
        return !!tag && (item.g || []).some((t) => norm(t) === tag);
      }

      reset() {
        this.filters.forEach((f) => {
          if (f.select) f.select.value = '';
        });
        if (this.stock) this.stock.value = this.stockDefault;
        this.expanded = false;
        this.update();
      }

      card(item) {
        const k = item.k || {};
        const tag = this.cfg.nameTag === 'h2' ? 'h2' : 'h3';
        const status = this.inStock(item) ? [this.stockWords(item), ''] : this.madeToOrder(item) ? [this.cfg.orderLabel, ''] : !item.a ? ['Sold out', ' spf__status--out'] : null;
        const was = item.c > item.p ? '<s><span class="spf__sr">Regular price </span>' + money(item.c) + '</s>' : '';
        return '<li class="spf__item"><a class="spf__card" href="' + esc(item.u) + '">' +
          '<span class="spf__top">' +
          (item.i ? '<span class="spf__photo"><img src="' + esc(item.i) + '" alt="" width="240" height="240" loading="lazy" decoding="async"></span>' : '') +
          '<span class="spf__id"><span class="spf__eyebrow">' + esc(k.e || item.v) + '</span>' +
          '<' + tag + ' class="spf__name">' + esc(k.n || item.t) + '</' + tag + '></span></span>' +
          (k.o ? '<span class="spf__note">' + esc(k.o) + '</span>' : '') +
          '<span class="spf__line"><span class="spf__facts">' + esc(k.f) + '</span>' +
          '<span class="spf__price"><strong>' + money(item.p) + '</strong>' + was + '</span></span>' +
          (status ? '<span class="spf__status' + status[1] + '">' + esc(status[0]) + '</span>' : '') +
          (k.t ? '<span class="spf__tag">' + esc(k.t) + '</span>' : '') +
          '</a></li>';
      }

      update() {
        if (this.sort.selectedIndex < 0) this.sort.value = 'best';
        this.showStockNote();
        this.applied = this.menus();
        if (!this.items) return;
        this.remember();
        const chosen = this.filters.filter((f) => f.select && f.select.value !== '').map((f) => ({ f: f, option: f.list[Number(f.select.value)] }));
        const stockOnly = this.stock && this.stock.value === 'in';
        const fits = this.items.filter((item) => chosen.every((c) => this.test(item, c.f, c.option)));
        let matches = stockOnly ? fits.filter((item) => this.inStock(item) || this.madeToOrder(item)) : fits;
        const sort = this.sort.value;
        if (sort === 'low') matches = matches.map((item, i) => ({ item: item, i: i })).sort((a, b) => a.item.p - b.item.p || a.i - b.i).map((x) => x.item);

        const n = matches.length;
        const limit = Number(this.phone.matches ? this.cfg.initialMobile : this.cfg.initial) || 8;
        const shown = this.expanded ? matches : matches.slice(0, limit);
        this.grid.innerHTML = shown.map((item) => this.card(item)).join('');

        const one = this.cfg.one;
        const many = this.cfg.many;
        this.count.textContent = n === 0 ? 'No ' + many + ' match' : n === 1 ? '1 ' + one + ' matches' : n + ' ' + many + ' match';
        const stockWords = this.cfg.orderTag ? 'In stock or ' + String(this.cfg.orderLabel).toLowerCase() : 'In stock';
        this.basis.textContent = (stockOnly ? stockWords + ' · ' : '') + (sort === 'low' ? 'Lowest price first' : 'Our best sellers first');

        const hidden = fits.length - n;
        this.empty.hidden = n !== 0;
        if (n === 0) {
          const title = this.querySelector('[data-spf-empty-title]');
          const text = this.querySelector('[data-spf-empty-text]');
          if (stockOnly && hidden > 0) {
            const adj = (words) => String(words).trim().toLowerCase().replace(/\s+/g, '-');
            title.textContent = 'None of our ' + (this.cfg.orderTag ? 'in-stock or ' + adj(this.cfg.orderLabel) : 'in-stock') + ' ' + many + ' match all of that.';
            text.textContent = (hidden === 1 ? '1 ' + one + ' matches' : hidden + ' ' + many + ' match') + ' when you include the ones we don’t have in stock.';
            this.allBtn.textContent = 'Include ' + many + ' not in stock';
            this.allBtn.hidden = false;
          } else {
            title.textContent = 'None of our ' + many + ' match all of that.';
            text.textContent = this.cfg.emptyText;
            this.allBtn.hidden = true;
          }
        }
        this.more.hidden = n <= limit;
        this.more.textContent = this.expanded ? 'Show fewer' : 'Show all ' + n + ' matches';
        this.more.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
        this.headClear.hidden = chosen.length === 0 && (!this.stock || this.stock.value === this.stockDefault);
      }
    }

    customElements.define('sp-finder', SpFinder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glaze-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('glaze-finder')) return;

    const FINISH = { g: 'Gloss', s: 'Satin', m: 'Matte', t: 'Textured' };
    const TOOLS = /sieve|sample set|sample kit|rim cone|gum solution|pencil|crayon|flecks|specks|stains|crystals|luster|tinted potter|printing ink|semi-moist|base glazes/i;
    // Color words, for colors added to the store after the finder's data was made. The last color word wins: "Red Brown" is a brown.
    const WORDS = [
      ['b', 'blue|turquoise|teal|aqua|navy|indigo|sapphire|cobalt|cerulean|azure|lagoon'],
      ['g', 'green|celadon|oribe|pine|forest|jade|emerald|chartreuse|lime|olive|avocado|moss|seaweed|sage|mint|fern|leaf|seafoam'],
      ['v', 'purple|violet|lilac|lavender|plum|amethyst|mulberry|grape|eggplant|aubergine|wisteria'],
      ['p', 'pink|pinky|rose|blush|coral|flamingo|fuchsia|fuschia|magenta'],
      ['r', 'red|crimson|ruby|cherry|scarlet|maroon|burgundy|oxblood|cranberry'],
      ['o', 'orange|tangerine|pumpkin|peach|apricot|carrot|clementine|persimmon'],
      ['y', 'yellow|lemon|sunflower|canary|mustard|butter|gold|goldenrod|honey'],
      ['w', 'white|snow|clear|transparent|ivory|cream|vanilla|eggshell'],
      ['k', 'black|obsidian|charcoal|ebony|jet|onyx|gray|grey|slate|silver|graphite|pewter'],
      ['n', 'brown|chocolate|coffee|cocoa|tan|mocha|caramel|chestnut|walnut|umber|sienna|cinnamon|copper|bronze|rust|taupe|beige|sand']
    ];
    const BRANDS = [[/spectrum/i, 'Spectrum'], [/coyote/i, 'Coyote'], [/opulence|mid-?south/i, 'Opulence'], [/clayscapes/i, 'Clayscapes'], [/speedball/i, 'Speedball'], [/ritual/i, 'Ritual'], [/mayco/i, 'Mayco'], [/amaco/i, 'Amaco']];

    const colorFromName = (name) => {
      const words = name.replace(/^[A-Z]{0,4}-?\d+\w*\s*/, '').toLowerCase();
      let found = '';
      let at = -1;
      WORDS.forEach(([family, pattern]) => {
        const re = new RegExp('\\b(' + pattern + ')\\b', 'g');
        let m;
        while ((m = re.exec(words))) {
          if (m.index + m[0].length > at) {
            at = m.index + m[0].length;
            found = family;
          }
        }
      });
      return found;
    };
    const finishFromName = (name) => {
      const n = name.toLowerCase();
      if (/\bsatin\b/.test(n)) return 's';
      if (/\bmatte?\b|\bmatt\b/.test(n)) return 'm';
      if (/\bgloss/.test(n)) return 'g';
      if (/textur/.test(n)) return 't';
      return '';
    };
    const sizeOf = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ')
      .replace(/(\d)\s*(?:pounds?|lbs?)\b/, '$1 lb').replace(/(\d)\s*oz\b/, '$1 oz');
    // "TPL-03 ONYX" reads as "TPL-03 Onyx"
    const niceName = (raw) => raw.replace(/\s*\*[^*]*\*\s*/g, ' ').trim().split(/\s+/).map((word) => {
      if (/\d/.test(word) || word.length <= 2 || word !== word.toUpperCase() || word === word.toLowerCase()) return word;
      return word.split('-').map((part) => part.charAt(0) + part.slice(1).toLowerCase()).join('-');
    }).join(' ').replace(/ ,/g, ',');
    const coneNumber = (text) => (/^0\d$/.test(text) ? -Number(text.slice(1)) : Number(text));
    // Older Safari (iPads before iOS 14) has no replaceChildren, and media queries there only take addListener.
    const fill = (parent, nodes) => {
      while (parent.firstChild) parent.removeChild(parent.firstChild);
      const frag = document.createDocumentFragment();
      nodes.forEach((node) => frag.appendChild(node));
      parent.appendChild(frag);
    };
    const onMedia = (query, fn) => (query.addEventListener ? query.addEventListener('change', fn) : query.addListener(fn));
    const offMedia = (query, fn) => (query.removeEventListener ? query.removeEventListener('change', fn) : query.removeListener(fn));

    class GlazeFinder extends HTMLElement {
      connectedCallback() {
        if (this.ready) {
          // Moved on the page (the theme editor does this): listen again.
          this.listen();
          this.update();
          return;
        }
        this.ready = true;
        this.data = JSON.parse(this.querySelector('[data-gf-static]').textContent);
        this.filters = Array.from(this.querySelectorAll('[data-gf-filter]'));
        this.select = (name) => this.querySelector('[data-gf-filter="' + name + '"]');
        this.finishField = this.querySelector('[data-gf-finish-field]');
        this.count = this.querySelector('[data-gf-count]');
        this.grid = this.querySelector('[data-gf-grid]');
        this.empty = this.querySelector('[data-gf-empty]');
        this.error = this.querySelector('[data-gf-error]');
        this.more = this.querySelector('[data-gf-more]');
        this.headClear = this.querySelector('[data-gf-clear="head"]');
        this.phone = window.matchMedia('(max-width: 749px)');
        this.shown = 0;
        this.items = null;
        const currency = this.dataset.currency || 'USD';
        try {
          this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency });
        } catch (e) {
          this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
        }

        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-gf-filter]')) return;
          this.shown = 0;
          this.update();
        });
        this.querySelectorAll('[data-gf-clear]').forEach((button) => button.addEventListener('click', () => this.reset()));
        this.querySelector('[data-gf-retry]').addEventListener('click', () => this.load());
        this.more.addEventListener('click', () => this.toggleMore());
        this.onPhone = () => {
          this.shown = 0;
          this.update();
        };
        // Back and Forward: the browser puts the shopper's menu choices back after the page has loaded,
        // without telling the page, so read the menus again whenever the page is shown.
        this.onShow = () => {
          if (JSON.stringify(this.values()) === this.applied) return;
          this.shown = 0;
          this.update();
        };
        this.listen();

        this.load();
      }

      disconnectedCallback() {
        if (!this.phone) return;
        offMedia(this.phone, this.onPhone);
        window.removeEventListener('pageshow', this.onShow);
      }

      listen() {
        onMedia(this.phone, this.onPhone);
        window.addEventListener('pageshow', this.onShow);
      }

      async load() {
        this.error.hidden = true;
        this.count.textContent = 'Loading glazes…';
        try {
          // In the theme editor the section carries the glazes itself; customers' pages load them in the background.
          const inline = this.querySelector('[data-glaze-finder-data]');
          const first = inline ? JSON.parse(inline.textContent) : await this.page(1);
          const rest = [];
          if (!inline) for (let n = 2; n <= first.pages; n += 1) rest.push(this.page(n));
          const products = first.products.concat(...(await Promise.all(rest)).map((page) => page.products));
          this.items = this.build(products);
          this.fillBrands();
          this.update();
        } catch (e) {
          this.items = null;
          this.count.textContent = '';
          fill(this.grid, []);
          this.empty.hidden = true;
          this.more.hidden = true;
          this.error.hidden = false;
        }
      }

      async page(n) {
        const src = this.dataset.src;
        const url = src + (src.indexOf('?') === -1 ? '?' : '&') + 'section_id=glaze-finder-data&sort_by=best-selling&page=' + n;
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Glaze data: HTTP ' + response.status);
        const text = await response.text();
        const found = text.match(/<script[^>]*data-glaze-finder-data[^>]*>([\s\S]*?)<\/script>/);
        if (!found) throw new Error('Glaze data: not found');
        return JSON.parse(found[1]);
      }

      // Unknown listing (added after the finder's data was made): read what we can from its title.
      guessLine(product) {
        const title = product.t;
        const under = /underglaze/i.test(title);
        let cone = '';
        let fire = '';
        const range = title.match(/cone\s*(0?\d{1,2})\s*(?:-|–|\/|to)\s*(0?\d{1,2})/i);
        const single = title.match(/cone\s*(0?\d{1,2})\b/i);
        if (range || single) {
          const a = coneNumber(range ? range[1] : single[1]);
          const b = range ? coneNumber(range[2]) : a;
          const lo = Math.min(a, b);
          const hi = Math.max(a, b);
          if (lo <= -1) fire += 'l';
          if (hi >= 4 && lo <= 6) fire += 'm';
          if (hi >= 8) fire += 'h';
          cone = 'Cone ' + (range ? range[1] + '–' + range[2] : single[1]);
        }
        if (/raku/i.test(title)) {
          fire += 'r';
          cone = cone || 'Raku';
        }
        if (!fire && /low[- ]fire/i.test(title)) {
          fire = 'l';
          cone = 'Low fire';
        }
        if (!fire && /mid[- ](?:fire|range)/i.test(title)) {
          fire = 'm';
          cone = 'Mid-range';
        }
        const brand = (BRANDS.find(([re]) => re.test(product.b + ' ' + title)) || [null, (product.b || '').split(' ')[0]])[1];
        const line = title.replace(/\s*\((?:pint|gallon|8 ?oz)\)\s*/gi, ' ').replace(/[:\s]+$/, '').trim();
        return [line, brand, under ? 'u' : 'g', cone, fire, '', under ? ['2 oz', '4 oz', 'pint'] : ['pint'], '', 1];
      }

      build(products) {
        const lines = this.data.lines;
        const colors = this.data.colors;
        const skip = new Set(this.data.skip);
        const excluded = new Set(this.data.exclude);
        const root = (this.dataset.root || '/').replace(/\/?$/, '/');
        const items = [];
        products.forEach((product, pi) => {
          if (excluded.has(product.h)) return;
          let line = lines[product.h];
          if (!line) {
            if (TOOLS.test(product.t)) return;
            line = this.guessLine(product);
          }
          const known = colors[product.h] || {};
          const names = product.o.map((name) => String(name).trim().toLowerCase());
          const ci = names.findIndex((name) => name === 'color' || name === 'colour');
          const si = names.findIndex((name) => name === 'size');
          const groups = new Map();
          let photo = '';
          product.v.forEach((v) => {
            const option = (i) => (i === 0 ? v[1] : i === 1 ? v[2] : null);
            const color = ci >= 0 ? String(option(ci) || '').trim() : '';
            if (v[5] !== 0) photo = v[5]; // 0: same photo as the variant before
            if (!groups.has(color)) groups.set(color, []);
            groups.get(color).push({ id: v[0], size: si >= 0 ? sizeOf(option(si)) : '', price: v[3], available: v[4] === 1, image: photo });
          });
          const pref = line[6];
          const rank = (v) => [v.available ? 0 : 1, pref.indexOf(v.size) !== -1 ? pref.indexOf(v.size) : v.size ? 99 : pref.length, v.price];
          const before = (a, b) => {
            const x = rank(a);
            const y = rank(b);
            return x[0] - y[0] || x[1] - y[1] || x[2] - y[2];
          };
          let pos = -1;
          groups.forEach((variants, color) => {
            pos += 1;
            if (skip.has(product.h + '|' + color)) return;
            const facts = known[color];
            const name = (facts && facts[3]) || (color ? niceName(color) : product.t);
            const pick = variants.slice().sort(before)[0];
            const under = line[2] === 'u';
            items.push({
              name,
              line: line[0],
              brand: line[1],
              type: line[2],
              cone: line[3],
              fire: line[4],
              color: facts ? facts[0] : colorFromName(name),
              finish: under ? '' : facts ? facts[1] : finishFromName(color || product.t) || line[5],
              units: facts ? facts[2] : 0,
              food: line[8] === 1 && !/not food/i.test(color || product.t),
              available: pick.available,
              price: pick.price,
              unit: line[7] || pick.size,
              image: pick.image,
              href: root + 'products/' + product.h + '?variant=' + pick.id,
              pi,
              pos
            });
          });
        });
        // In stock first, then best sellers (past year), then the store's best-selling order.
        items.sort((a, b) => (b.available - a.available) || (b.units - a.units) || (a.pi - b.pi) || (a.pos - b.pos));
        return items;
      }

      fillBrands() {
        const select = this.select('brand');
        const current = select.value;
        const totals = new Map();
        this.items.forEach((item) => {
          const t = totals.get(item.brand) || { units: 0, n: 0 };
          t.units += item.units;
          t.n += 1;
          totals.set(item.brand, t);
        });
        const brands = Array.from(totals.keys()).sort((a, b) => totals.get(b).units - totals.get(a).units || totals.get(b).n - totals.get(a).n || a.localeCompare(b));
        fill(select, [new Option('Any brand', 'any')].concat(brands.map((brand) => new Option(brand, brand))));
        select.value = brands.indexOf(current) !== -1 ? current : 'any';
      }

      values() {
        const v = {};
        this.filters.forEach((select) => {
          v[select.dataset.gfFilter] = select.value;
        });
        return v;
      }

      reset() {
        this.filters.forEach((select) => {
          select.value = 'any';
        });
        this.shown = 0;
        this.update();
      }

      limit() {
        return Number(this.phone.matches ? this.dataset.initialMobile : this.dataset.initial) || 8;
      }

      toggleMore() {
        const n = this.results.length;
        if (this.shown < n) {
          this.shown += Number(this.dataset.step) || 24;
          this.update();
        } else {
          this.shown = 0;
          this.update();
          const top = this.querySelector('.gf__results').getBoundingClientRect().top;
          if (top < 0) this.querySelector('.gf__results').scrollIntoView({ block: 'start' });
        }
      }

      card(item) {
        const el = (tag, cls, text) => {
          const node = document.createElement(tag);
          if (cls) node.className = cls;
          if (text != null) node.textContent = text;
          return node;
        };
        const li = el('li', 'gf__item');
        const a = el('a', 'gf__card');
        a.href = item.href;
        const img = el('img', 'gf__photo');
        img.alt = '';
        img.width = 128;
        img.height = 128;
        img.loading = 'lazy';
        img.decoding = 'async';
        if (item.image) img.src = item.image;
        const id = el('span', 'gf__id');
        const top = [item.cone, FINISH[item.finish] || '', item.type === 'u' ? 'Underglaze' : ''].filter(Boolean).join(' · ');
        if (top) id.append(el('span', 'gf__top', top));
        id.append(el(this.dataset.nameTag || 'h3', 'gf__name', item.name));
        const meta = el('span', 'gf__meta');
        const price = el('span', 'gf__price');
        price.append(el('strong', null, this.money.format(item.price / 100)));
        if (item.unit) price.append(' ', el('span', 'gf__unit', item.unit));
        meta.append(price);
        if (!item.available) meta.append(el('span', 'gf__flag gf__sold', 'Sold out'));
        else if (!item.food) meta.append(el('span', 'gf__flag', 'Not food safe'));
        a.append(img, id, el('span', 'gf__line', item.line), meta);
        li.append(a);
        return li;
      }

      update() {
        const f = this.values();
        this.applied = JSON.stringify(f);
        const underOnly = f.type === 'u';
        const finish = underOnly ? 'any' : f.finish;
        this.finishField.hidden = underOnly;
        this.headClear.hidden = Object.keys(f).every((k) => f[k] === 'any' || (k === 'finish' && underOnly));
        if (!this.items) return;

        this.results = this.items.filter((item) =>
          (f.type === 'any' || item.type === f.type) &&
          (f.fire === 'any' || item.fire.indexOf(f.fire) !== -1) &&
          (f.color === 'any' || item.color === f.color) &&
          (finish === 'any' || item.finish === finish) &&
          (f.brand === 'any' || item.brand === f.brand));
        const n = this.results.length;
        const limit = this.limit();
        this.shown = Math.max(this.shown, limit);
        const shown = Math.min(this.shown, n);
        fill(this.grid, this.results.slice(0, shown).map((item) => this.card(item)));

        this.count.textContent = n === 0 ? 'No glazes match' : n === 1 ? '1 glaze matches' : n.toLocaleString('en-US') + ' glazes match';
        this.empty.hidden = n !== 0;
        this.more.hidden = n <= limit;
        const left = n - shown;
        const step = Number(this.dataset.step) || 24;
        this.more.textContent = left > 0 ? 'Show ' + Math.min(step, left) + ' more' : 'Show fewer';
        this.more.setAttribute('aria-label', left > 0 ? 'Show ' + Math.min(step, left) + ' more of ' + n.toLocaleString('en-US') + ' matches' : 'Show fewer glazes');
      }
    }

    customElements.define('glaze-finder', GlazeFinder);
  })();

  } catch(e) { console.error(e); }
})();
})();
